import { useIntl } from 'react-intl';

import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { BannerLayout, BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { Text, TextType } from 'ui-components/components/text';

import getMarketplaceDisplayName from '../../components/data-driven-logo/get-marketplace-display-name';
import messages from '../messages';
import type { MarketplaceServiceRecommendation } from './marketplace-service-recommendation-types';

export const MarketplaceServiceRecommendationBanner = ({ marketplaceId, recommendedShippingService }: MarketplaceServiceRecommendation) => {
  const intl = useIntl();
  const marketplaceNameMessageDescriptor = getMarketplaceDisplayName(marketplaceId);
  const marketplaceName = intl.formatMessage(marketplaceNameMessageDescriptor);

  return (
    <BannerMessageV2
      content={
        <Text
          formattedMessageValues={{
            marketplaceName,
            recommendedShippingService,
          }}
          textType={TextType.Caption}
          value={messages.recommendedShippingService}
        />
      }
      layout={BannerLayout.Inline}
      status={BannerStatus.Warning}
    />
  );
};
